import * as Programs from "../../programs";
import processMap from "../../util/processMap";

const id = "ph-employee";
const map = `
......12-34...
..............
..............
..............
@------------A
--@---------B-
@------------C
..............
..............
..............
...56-78......
`;
const enemies = [Programs.GuardPup, Programs.Watchman, Programs.GuardPup];
const creditValues: number[] = [350, 350, 250, 330, 350, 330, 280, 330];

const level = processMap(id, map, enemies, creditValues);

export default level;

// 5#0:27
